import { render, staticRenderFns } from "./payRecord.vue?vue&type=template&id=dc32f72e&scoped=true"
import script from "./payRecord.vue?vue&type=script&lang=js"
export * from "./payRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc32f72e",
  null
  
)

export default component.exports